import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { ICheckIsFavoriteService } from "shared/classroom/preview-screen/core";
import { AddToFavoritesButtonConfig } from "./components/add-to-favorites-button/add-to-favorites-button.component";

export const SLIDE_SYNC_CHECK_IS_FAVORITE_SERVICE =
    new InjectionToken<ICheckIsFavoriteService>('CHECK_IS_FAVORITE_SERVICE');

/** Enable preview of and navigation to next/prev/extension slides if this setting is `true` and the client is a presentational client. */
export const SLIDE_SYNC_NAVIGATION_PREVIEW_ENABLED = new InjectionToken<
    Observable<boolean>
>('NAVIGATION_PREVIEW_ENABLED');


export interface SlideSyncUiConfig {
    addToFavoriteButton: AddToFavoritesButtonConfig;
}
export const SLIDE_SYNC_UI_CONFIG = new InjectionToken<SlideSyncUiConfig>('SLIDE_SYNC_UI_CONFIG', {
    factory: () => ({
        addToFavoriteButton: {
            fontSet: 'material-symbols-outlined',
            fontIconChecked: 'favorite',
            fontIconUnchecked: 'favorite',
        },
    }),
});
